import React from 'react'
import { Sidebar, Topbar } from '@/components/AccountShell'
import { useLang } from '@/lib/lang'

export default function Refer() {
  const { t } = useLang()
  const r = t.acct.refer

  return (
    <div className="app-shell">
      <Sidebar />
      <div className="main-pane">
        <Topbar crumbs={[t.acct.nav.refer]} />
        <div className="content">
          <div className="kicker accent" style={{ marginBottom: 10 }}>{r.eyebrow}</div>
          <h1 className="h-display" style={{ fontSize: 36, margin: "0 0 16px" }}>
            {r.title_1} <span className="font-serif" style={{ color: "var(--terracotta)", fontWeight: 400 }}>{r.title_word} {r.title_2}</span>
          </h1>
          <p style={{ fontSize: 16, color: "var(--muted)", maxWidth: 540, lineHeight: 1.5, margin: "0 0 24px" }}>
            {r.blurb}
          </p>
          <div className="tile" style={{ padding: 20, maxWidth: 480, marginBottom: 16, background: "var(--paper)" }}>
            <div className="kicker" style={{ marginBottom: 8 }}>{r.your_code}</div>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <code style={{ fontFamily: "'Geist Mono', monospace", fontSize: 24, fontWeight: 600, color: "var(--terracotta)" }}>MARIA-CASA</code>
              <button className="btn" style={{ padding: "8px 14px", marginLeft: "auto" }}>{r.copy}</button>
            </div>
          </div>
          <p style={{ fontSize: 13, color: "var(--muted)" }}>
            {r.or_share} <a href="#" style={{ color: "var(--terracotta)" }}>{r.link_pre}</a>
          </p>
        </div>
      </div>
    </div>
  )
}
